import { is } from 'ramda';

import { COMMON } from 'translations';

const LANG_REGEX = /^([a-z]{2})-[a-zA-Z]{2}/;

export const FR = 'fr';
export const EN = 'en';
export const PRISMIC_FR = 'fr-fr';
export const PRISMIC_EN = 'en-gb';

export const PRISMIC_LOCALES = [PRISMIC_FR, PRISMIC_EN];

export const LOCALES = [FR, EN];

export const getLangTranslation = (lang) => COMMON[lang];

/**
 * A function to transform a locale string into a lang string
 *
 * @param {string} locale
 * @return {string}
 * @example getLang('fr-FR') => 'fr
 */
export const getLang = (locale) => {
  const langs = LANG_REGEX.exec(locale);

  if (langs && is(String, langs[1])) {
    return langs[1];
  }

  return locale;
};

/**
 * A function to transform a locale string into a lang string
 *
 * @param {string} locale
 * @return {string}
 * @deprecated Use getLang instead
 */
export const getLocale = getLang;

export const getLocaleFull = (lang) => {
  switch (getLang(lang)) {
    case 'fr':
      return 'fr_FR';
    case 'en':
      return 'en_GB';
    default:
      return '*';
  }
};

export const toPrismicLang = (lang) => {
  switch (getLang(lang)) {
    case 'fr':
      return 'fr-fr';
    case 'en':
      return 'en-gb';
    default:
      return '*';
  }
};
